const STORAGE_KEY = 'fair_distinct_id_v1';
const EXPIRY_KEY = 'fair_distinct_id_expiry';
const EXPIRY_MS = 60 * 60 * 1000; // 1 hour

export const updateClaimOnUserVisit = async (claimNumber: string) => {
  try {
    const distinctId = getStoredId();

    if (!distinctId) return;

    await fetch(
      (import.meta.env.VITE_BACKEND_API_BASE_URL || 'http://localhost:8080') +
        '/user-visit/claim/update',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          distinctId,
          claimNumber,
        }),
      }
    );
  } catch (err) {
    console.error('User visit claim update: ', err);
  }
};

export function getStoredId(): string | null {
  const id = localStorage.getItem(STORAGE_KEY);
  const expiry = localStorage.getItem(EXPIRY_KEY);
  if (!id || !expiry || new Date().getTime() > parseInt(expiry)) return null;
  return id;
}

export function setStoredId(id: string) {
  const expiry = new Date().getTime() + EXPIRY_MS;
  localStorage.setItem(STORAGE_KEY, id);
  localStorage.setItem(EXPIRY_KEY, expiry.toString());
}

export function generateUUID(): string {
  return crypto.randomUUID();
}

export const getIPAsync = async () => {
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  return data.ip;
};

export function getUTMTags(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const result: Record<string, string> = {};
  utmKeys.forEach((key) => {
    const value = params.get(key);
    if (value) result[key] = value;
  });
  return result;
}

export function patchHistoryListeners(callback: () => void) {
  const origPushState = history.pushState;
  const origReplaceState = history.replaceState;

  history.pushState = function (...args) {
    origPushState.apply(this, args);
    window.dispatchEvent(new Event('fair:route-change'));
  };

  history.replaceState = function (...args) {
    origReplaceState.apply(this, args);
    window.dispatchEvent(new Event('fair:route-change'));
  };

  window.addEventListener('popstate', callback);
  window.addEventListener('fair:route-change', callback);

  return () => {
    history.pushState = origPushState;
    history.replaceState = origReplaceState;
    window.removeEventListener('popstate', callback);
    window.removeEventListener('fair:route-change', callback);
  };
}
